import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import EscudoNacional from "../components/common/EscudoNacional";

/**
 * Thank-you page — ALWAYS Spanish. Standalone (no Header/Footer/CookieBanner).
 */
const ThankYou = () => {
  const { t } = useTranslation();

  return (
    <div
      data-testid="thankyou-page"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(180deg, var(--pum-navy) 0%, var(--pum-navy-2) 60%, var(--pum-ink) 100%)",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="pum-flag-ribbon pum-flag-ribbon--thin" />
      <header
        className="pum-container"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.85rem",
          padding: "1.5rem 1.25rem",
        }}
      >
        <EscudoNacional size={40} />
        <span
          style={{
            fontFamily: "var(--font-serif)",
            fontSize: "1.35rem",
            fontWeight: 900,
            color: "#fff",
          }}
        >
          {t("brand.name")}
        </span>
      </header>

      <main
        className="pum-container"
        style={{
          flex: 1,
          display: "grid",
          placeItems: "center",
          padding: "3rem 1.25rem 4rem",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: 640 }}>
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: "var(--pum-emerald)",
              display: "grid",
              placeItems: "center",
              margin: "0 auto 1.75rem",
            }}
          >
            <CheckCircle2 size={40} color="#fff" strokeWidth={2.2} />
          </div>

          <span
            style={{
              display: "inline-block",
              fontSize: "0.72rem",
              letterSpacing: "0.24em",
              textTransform: "uppercase",
              color: "var(--pum-emerald)",
              fontWeight: 700,
              marginBottom: "0.75rem",
            }}
          >
            {t("thankyou.eyebrow")}
          </span>

          <h1
            data-testid="thankyou-title"
            style={{
              color: "#fff",
              fontSize: "clamp(2rem, 4vw, 3rem)",
              fontWeight: 900,
              lineHeight: 1.1,
              marginBottom: "1.25rem",
            }}
          >
            {t("thankyou.title")}
          </h1>

          <p style={{ color: "#C6D2E5", fontSize: "1.05rem", lineHeight: 1.6, marginBottom: "1rem" }}>
            {t("thankyou.subtitle")}
          </p>
          <p style={{ color: "#8FA5C7", fontSize: "0.95rem", lineHeight: 1.55, marginBottom: "2rem" }}>
            {t("thankyou.next")}
          </p>

          <Link
            to="/"
            data-testid="thankyou-back-home"
            className="pum-btn pum-btn--emerald"
            style={{ padding: "1rem 1.75rem", fontSize: "0.95rem" }}
          >
            <ArrowLeft size={16} /> {t("thankyou.back")}
          </Link>

          <div style={{ marginTop: "3rem", display: "flex", alignItems: "center", gap: "0.75rem", justifyContent: "center", color: "#8FA5C7", fontSize: "0.8rem" }}>
            <div style={{ height: 2, width: 40, background: "var(--pum-red)" }} />
            {t("footer.flag")}
          </div>
        </div>
      </main>
    </div>
  );
};

export default ThankYou;
